export enum BlogPostStatusEnum {
  Draft = 1,
  Published = 2,
  Archived = 3,
}
